<template>
    <div class='page'>
        <el-form
            v-if='isSearch'
            :model='queryForm'
            ref='searchForm'
            label-width='80px'
            :inline='true'
            size='small'
            class='query-form'
            @submit.native.prevent
        >
            <el-form-item label='手机号' prop='userMobile'>
                <el-input
                    v-model='queryForm.userMobile'
                    style='width: 177px'
                    placeholder='请输入手机号'
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type='primary' icon='el-icon-search' size='small' @click='handleSearch'>查询</el-button>
                <el-button icon='el-icon-refresh' size='small' @click='handleReset'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'></div>
                <div class='icon-group'>
                    <span class='icon-box' title='搜索' @click='toggleSearch'>
                        <Icon color='#606266'>
                            <Search />
                        </Icon>
                    </span>
                    <span class='icon-box' title='刷新' @click='refreshList'>
                        <Icon color='#606266'>
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <el-table
                height='100%'
                :data='tableData.list'
                row-key='id'
                border
                v-loading='tableLoading'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size='small'
            >
                <el-table-column align='center' prop='userId' label='用户ID' min-width='120' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='userName' label='用户名' min-width='120' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='userMobile' label='手机号' min-width='130'></el-table-column>
                <el-table-column align='center' prop='newPoolAmount' label='新增权益数量' min-width='120'></el-table-column>
                <el-table-column align='center' prop='oldPoolAmount' label='存量权益数量' min-width='120'></el-table-column>
                <el-table-column align='center' prop='totalAmount' label='总权益数量' min-width='120'></el-table-column>
                <el-table-column align='center' prop='createTime' label='创建时间' min-width='160'>
                    <template slot-scope='scope'>
                        {{ scope.row.createTime ? $moment(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : '--' }}
                    </template>
                </el-table-column>
                <el-table-column align='center' label='操作' min-width='160' fixed='right'>
                    <template slot-scope='scope'>
                        <el-button type='text' size='small' @click='handleDetail(scope.row)'>详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='(size) => { queryForm.pageSize = size; getTableData(); }'
                    @current-change='(page) => { queryForm.pageNum = page; getTableData(); }'
                    :current-page='queryForm.pageNum'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='queryForm.pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    background
                    :total='tableData.total'>
                </el-pagination>
            </div>
        </div>
        <el-dialog
            :visible.sync='detailShow'
            title='详情'
            width='80%'
            :before-close='handleCloseDetail'
        >
            <el-table
                :data='detailData.list'
                border
                size='small'
                v-loading='detailLoading'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
            >
                <el-table-column align='center' prop='sourceTypeName' label='类型' min-width='120'></el-table-column>
                <el-table-column align='center' prop='buyPrice' label='购买价格' min-width='120'></el-table-column>
                <el-table-column align='center' prop='buyAmount' label='购买数量' min-width='120'></el-table-column>
                <el-table-column align='center' prop='remainingAmount' label='剩余数量' min-width='120'></el-table-column>
                <el-table-column align='center' prop='costAmount' label='花费数量' min-width='120'></el-table-column>
                <el-table-column align='center' prop='remark' label='备注' min-width='120'></el-table-column>
                <el-table-column align='center' prop='createTime' label='创建时间' min-width='160'>
                    <template slot-scope='scope'>
                        {{ scope.row.createTime ? $moment(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : '--' }}
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='(size) => { detailPager.pageSize = size; getDetailData(); }'
                    @current-change='(page) => { detailPager.pageNum = page; getDetailData(); }'
                    :current-page='detailPager.pageNum'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='detailPager.pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    background
                    :total='detailData.total'>
                </el-pagination>
            </div>
            <div slot='footer' class='dialog-footer'>
                <el-button @click='handleCloseDetail'>关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Refresh, Search } from '@v2icons/tabler';
import { get } from '@/utils/request.js';

export default {
    name: 'DataRights',
    components: {
        Refresh,
        Search
    },
    data() {
        return {
            isSearch: false,
            queryForm: {
                pageNum: 1,
                pageSize: 10,
                userMobile: ''
            },
            tableData: {
                list: [],
                total: 0
            },
            tableLoading: false,
            showUserId: '',
            detailData: {
                list: [],
                total: 0
            },
            detailPager: {
                pageNum: 1,
                pageSize: 10
            },
            detailLoading: false,
            detailShow: false
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        toggleSearch() {
            this.isSearch = !this.isSearch;
        },
        getTableData() {
            this.tableLoading = true;
            get('/shop/admin/vbao/holding/findList', { ...this.queryForm }).then((res) => {
                if (res.success) {
                    if (res.page) {
                        this.tableData.list = res.page.list;
                        this.tableData.total = res.page.total;
                    } else {
                        this.tableData.list = res.list || [];
                        this.tableData.total = this.tableData.list.length;
                    }
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        handleSearch() {
            this.queryForm.pageNum = 1;
            this.getTableData();
        },
        handleReset() {
            this.queryForm.userMobile = '';
            this.queryForm.pageNum = 1;
            this.getTableData();
        },
        refreshList() {
            this.getTableData();
        },
        handleDetail(row) {
            this.showUserId = row.userId;
            this.detailPager.pageNum = 1;
            this.detailPager.pageSize = 10;
            this.detailShow = true;
            this.getDetailData();
        },
        getDetailData() {
            this.detailLoading = true;
            get('/shop/admin/vbao/position/findList', { userId: this.showUserId, ...this.detailPager }).then((res) => {
                if (res.success) {
                    if (res.page) {
                        this.detailData.list = res.page.list;
                        this.detailData.total = res.page.total;
                    } else {
                        this.detailData.list = res.list || [];
                        this.detailData.total = this.detailData.list.length;
                    }
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            }).finally(() => {
                this.detailLoading = false;
            });
        },
        handleCloseDetail() {
            this.detailShow = false;
            this.showUserId = '';
            this.detailPager.pageNum = 1;
            this.detailPager.pageSize = 10;
            this.detailData.list = [];
            this.detailData.total = 0;
        }
    }
};
</script>

<style scoped></style>
